import { Component, Input } from '@angular/core';

@Component({
  selector: 'atom-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  @Input() isLoading: boolean = false;
}
